<!-- Vue Component -->
<template>
  <div style="width:100%;  overflow: hidden;">
    <TopNavigation activeApp="IP Manager"/>
    <div class="tree-nav">
          <tree
            :data="items"
            :options="options"
            ref="tree"
            @node:selected="onNodeSelected"
          />
    </div> <!--tree-nav-->

    <div class="content">
      <b-row align-h="between">
        <b-col cols="4" style="text-align:left;"><h4>{{selectedNode.text}}</h4></b-col>
        <b-col cols="4" style="text-align:right">
              <!--b-button v-on:click='edit' variant="info" size="sm" class="mr-1">Edit</b-button>
              <b-button v-on:click='add' variant="info" size="sm">Add Block</b-button-->
        </b-col>
      </b-row>

      <hr/>

      <b-row align-h="start">
        <b-col cols="3" style="text-align:left">Name:</b-col>
        <b-col style="text-align:left">{{selectedNode.text}}</b-col>
      </b-row>
      <b-row align-h="start">
        <b-col cols="3" style="text-align:left">Description:</b-col>
        <b-col style="text-align:left">Description</b-col>
      </b-row>
      <b-row align-h="start">
        <b-col cols="3" style="text-align:left">Type:</b-col>
        <b-col style="text-align:left">Net type</b-col>
      </b-row>
      <b-row align-h="start">
        <b-col cols="3" style="text-align:left">Organisation:</b-col>
        <b-col style="text-align:left">Net organisation</b-col>
      </b-row>


    </div> <!--content-->
  </div>
</template>

<script>
import IPManService from '@/api-services/ipman.service'

export default {
  name: 'ipmanbrowse',
  data() {
    return {
      items: [
      ],
      options: {
        checkbox: false
      },
      selectedNode:{text: 'All Networks'}
    }
  },
  props:{
    network: {}
  },
  created() {
    console.log(this.network)
    if (this.network) { //a specific network has been requested
      console.log("is network")
      this.items = [ {text: this.network.name.S}]
    } else{ //retrieve all items with parent_guid="network" here      
      console.log("no network passed")
      this.getAllNetworks()
    }
  },
  methods:{
    onNodeSelected(node) {
      this.selectedNode=node
      console.log(node)
    },
    getAllNetworks() {
      let promise = IPManService.getAllNetworks()
      return promise.then((data) => {
//        this.items = data.Items
      console.log(data.Items)
      data.Items.foreach(function(item){
        this.items.push({text})
      });
      this.items = [
          {text: 'All Networks', children:[
            {text: 'Echo Supernet'},
            {text: 'Test 1'},
            {text: 'Test 2', children: [
              {text: '10.70.0.0/16 (Block1)', children:[
                {text: '10.70.0.0/19 ()'},
                {text: '10.70.32.0/19 ()'},
                {text: '10.70.64.0/18 ()'},
                {text: '10.70.128.0/18 ()'},
                {text: '10.70.192.0/18 ()'},
              ]},
            ]}
          ]},
        ]
      }).catch(error => {
        // Here we could override the busy state, setting isBusy to false
        // this.isBusy = false
        // Returning an empty array, allows table to correctly handle
        // internal busy state in case of error
        this.items=[]
        this.totalRows = this.items.length
        //return []
      })        
    },
  }
}
</script>

<style>
.tree-nav {
  width: 380px;
  float:left; /* add this */
  background-color: #f9f9f9; 
  overflow-y: auto;

}
.content{
  overflow: hidden;
}
   
</style>